import React, { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import AllHotelsComponent from './components/AllHotelsListingComponent'


const AllHotelsPage = () => {






  return (


      <>
        {/* <h1>All Hotels</h1> */}

        <AllHotelsComponent />

      </>



  )
}


const AllHotelsWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {/* {intl.formatMessage({ id: 'MENU.AllHotels' })} */}

        AllHotels

        
        </PageTitle>
      <AllHotelsPage />
    </>
  )
}

export { AllHotelsWrapper }
